















































































import { ClientAccountTaskHistory } from '@/shared/clients/client-account-task-history';
import { TaskType } from '@/shared/task-type';
import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const usersModule = namespace('users');

@Component
export default class ViewClientTaskDialog extends Vue {
    @Prop({ required: true }) private task!: ClientAccountTaskHistory;
    @Prop({ required: true }) private visible!: boolean;

    @usersModule.Getter('users') private users!: Array<User>;

    private isVisible = this.visible;

    private get taskTypeDescription(): string {
        if (this.task.type == null) {
            return '';
        }

        switch (this.task.type) {
            case TaskType.RetrieveWillPacket:
                return 'Retrieve Will Packet';
            case TaskType.SendConfirmationLetter:
                return 'Send Confirmation Letter';
            default:
                return '';
        }
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private formatUserName(id: string | null): string {
        if (id == null) {
            return 'Unknown';
        }

        const user = this.users.find((u) => u.id === id);
        return user == null ? id : `${user.firstName == null ? '' : user.firstName.trim()} ${user.lastName == null ? '' : user.lastName.trim()}`;
    }
}
